import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class FormattedTime extends Component {
  render() {
    const { value } = this.props;
    const date = new Date(value);
    const mm = date.getMonth() + 1; // getMonth() is zero-based
    const dd = date.getDate();

    const formated = [
      date.getFullYear(),
      (mm > 9 ? '' : '0') + mm,
      (dd > 9 ? '' : '0') + dd
    ].join('.');

    return (
      <span>{formated}</span>
    );
  }
}

FormattedTime.propTypes = {
  value: PropTypes.node.isRequired
};



// WEBPACK FOOTER //
// ./src/components/FormattedTime/index.js